// Troco nas mensagens do pedido (13/10/2026, 💡 #82: pedido de R$ 18 com troco para R$ 50; a loja mandou R$ 3 de
// frete e as mensagens de "Enviar frete" e "Avisou Motoboy" não traziam o troco, que passou a R$ 29). A conta é a do
// card de Pedidos: Dinheiro → sobre o total; misto → sobre a parte em Dinheiro (o frete não mexe nas partes).
// O painel (Orders.tsx) e o robô do WhatsApp (whatsappBot.ts) montam a mensagem por aqui.

const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export interface PedidoComTroco {
  paymentMethod?: string | null;
  paymentParts?: ReadonlyArray<{ method: string; amount: number | string }> | null;
  changeFor?: number | string | null;
}

/** Troco sobre `total` (o salvo, ou o que a lojista está fechando com o frete). null = o pedido não pediu troco. */
export function trocoDoPedido(pedido: PedidoComTroco, total: number): { para: number; devolver: number } | null {
  const emDinheiro = Array.isArray(pedido.paymentParts) ? pedido.paymentParts.filter((p) => p.method === "Dinheiro") : [];
  const base = pedido.paymentMethod === "Dinheiro" ? total : emDinheiro.length > 0 ? Number(emDinheiro[0]!.amount) || 0 : null;
  const para = Number(pedido.changeFor);
  if (base === null || !(para > 0)) return null;
  return { para, devolver: Math.round((para - base) * 100) / 100 };
}

/** "Troco para R$ 50,00: R$ 29,00" (no motoboy, com o rótulo em negrito como os outros da mensagem). "" quando não há
 *  troco a devolver, inclusive se o total passou do valor que o cliente separou. */
export function linhaDoTroco(pedido: PedidoComTroco, total: number, opts: { negrito?: boolean } = {}): string {
  const t = trocoDoPedido(pedido, total);
  if (!t || t.devolver <= 0) return "";
  const rotulo = `Troco para ${brl.format(t.para)}:`;
  return `${opts.negrito ? `*${rotulo}*` : rotulo} ${brl.format(t.devolver)}`;
}

/** Mensagem da loja sem {troco}: a linha entra logo depois da linha do total (`ancora`: {total_atualizado} no frete,
 *  {valor_cobrar} no motoboy), onde o texto padrão a põe. Gravado com o padrão antigo, sai igual ao padrão novo. Não
 *  entra se a loja já escreve o troco à mão ("Troco para: R$ 00,00") nem se tirou o total (chave Pix, "PAGO"). */
export function comLinhaDoTroco(template: string, ancora: string): string {
  if (/troco/i.test(template)) return template;
  const i = template.indexOf(ancora);
  if (i < 0) return template;
  const fim = template.indexOf("\n", i);
  return fim < 0 ? `${template}\n{troco}` : `${template.slice(0, fim)}\n{troco}${template.slice(fim)}`;
}

/** Troca {troco} pela linha. Sem troco, a linha da variável some inteira, sem deixar linha em branco. */
export function trocarTroco(texto: string, linha: string): string {
  if (linha) return texto.replace(/\{troco\}/g, linha);
  return texto
    .split("\n")
    .filter((l) => l.trim() !== "{troco}")
    .map((l) => l.replace(/[ \t]*\{troco\}/g, ""))
    .join("\n");
}
